import { IconButton } from '@mui/material'
import { FC } from 'react'
import { useNotificationsStore } from '../../../store/storeNotifications'
import { useWrapperStore } from '../../../store/storeWrapper'
import { NotificationsBadge } from '../../NotificationsBadge/NotificationsBadge'
import MenuIcon from './../../../assets/icons/Menu.svg'

export const MobileHeaderActions: FC = () => {
    const { setOpenSidebar } = useWrapperStore((state) => state)
    const { numberOfUnreadNotifications } = useNotificationsStore((state) => state)

    const handleOpenSidebar = () => setOpenSidebar(true)

    return (
        <IconButton
            sx={{
                backgroundColor: '#fff',
            }}
            onClick={handleOpenSidebar}
            size="large">
            <NotificationsBadge count={numberOfUnreadNotifications} showZero={false}>
                <MenuIcon />
            </NotificationsBadge>
        </IconButton>
    )
}
